import { imgBannerLoyalty2 } from 'assets/images';
import React from 'react';

export default function Loyalty({ isMobile }) {
	return (
		<div className='md:mt-16px md:rounded-8px border border-EEEEEE overflow-hidden md:shadow-md select-none'>
			{isMobile ? (
				<img src={imgBannerLoyalty2} alt='' className="w-full"/>
			) : (
				<img src={imgBannerLoyalty2} alt='' className="w-full"/>
			)}
		</div>
	);
}
